import React from "react"
import { styled } from "@mui/material"

import Button from "components/ui/Button"

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode
}

function SubmitComponent({ children, ...restProps }: Props) {
  return <Submit {...restProps}>{children}</Submit>
}

export default SubmitComponent

const Submit = styled(Button)`
  background: ${({ theme }) => theme.palette.primary.main};
  cursor: ${({ disabled }) => (disabled ? "none" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? "0.2" : "1")};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "initial")};
  border-radius: 21px;
  border: none;
  color: #fff;
  font-size: 0.875rem;
  height: 44px;
  max-width: 376px;
  padding: 0 20px;
  text-align: center;
`
